/* @flow */
import { call, put, fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import * as actions from 'payments/reducers/activityRecipients'; // eslint-disable-line
import Activity from 'entities/Activity';
import ActivityRecipient from 'entities/ActivityRecipient';
import ActivityRecipients from 'collections/ActivityRecipients';

import type {  // eslint-disable-line
  loadActivityRecipientsAction,
  loadCurrentUserActivityResponseAction,
  patchActivityRecipientAction,
} from 'payments/reducers/activityRecipients';

export function* watchLoadActivityRecipients(): Generator<?any, ?any, ?any> {
  // $FlowFixMe ¯\_(ツ)_/¯
  yield* takeLatest('activityRecipients/ACTIVITY_RECIPIENTS_REQUEST', loadActivityRecipients);
}

export function* loadActivityRecipients(action: loadActivityRecipientsAction): Generator<?any, ?any, ?any> {
  try {
    const recipients: ?ActivityRecipients = yield call(Activity.getRecipients, action.activityId);
    if (recipients) {
      yield put(actions.loadActivityRecipientsSuccess(action.activityId, recipients));
    }
  } catch (e) {
    console.warn(e);
  }
}

export function* watchLoadCurrentUserActivityResponse(): Generator<?any, ?any, ?any> {
  // $FlowFixMe ¯\_(ツ)_/¯
  yield* takeLatest('activityRecipients/CURRENT_USER_ACTIVITY_RESPONSE_REQUEST', loadCurrentUserActivityResponse);
}

export function* loadCurrentUserActivityResponse(action: loadCurrentUserActivityResponseAction): Generator<?any, ?any, ?any> {
  try {
    const activityRecipient: ?ActivityRecipient = yield call(
      Activity.getCurrentUserRecipientResponse,
      action.activityId
    );

    if (activityRecipient) {
      yield put(actions.loadCurrentUserActivityResponseSuccess(
        activityRecipient,
        action.activityId
      ));
    }
  } catch (e) {
    console.warn(e);
  }
}

export function* watchPatchActivityRecipient(): Generator<?any, ?any, ?any> {
  // $FlowFixMe ¯\_(ツ)_/¯
  yield* takeLatest('activityRecipients/PATCH_ACTIVITY_RECIPIENT_REQUEST', patchActivityRecipient);
}

export function* patchActivityRecipient(action: patchActivityRecipientAction): Generator<?any, ?any, ?any> {
  try {
    const activityRecipient: ?ActivityRecipient = yield call(
      ActivityRecipient.patch,
      action.activityId,
      action.recipientId,
      action.data,
    );

    if (activityRecipient) {
      yield put(actions.patchActivityRecipientSuccess(
        action.activityId,
        activityRecipient,
      ));
    }
  } catch (e) {
    console.warn(e);
  }
}

export default function* root(): Generator<?any, ?any, ?any> {
  yield [
    fork(watchLoadCurrentUserActivityResponse),
    fork(watchLoadActivityRecipients),
    fork(watchPatchActivityRecipient),
  ];
}



// WEBPACK FOOTER //
// ./src/payments/sagas/activityRecipients.js